import { getInvitationCampaignInviteesStore } from '@front-app/store/modules/invitationCampaignInvitees';

export const InvitationCampaignInviteesStore = getInvitationCampaignInviteesStore();
